import { convertToPercentage } from '@/Utils/MathUtility';
import Formatter from '@/Utils/Formatter';
import { taxIdValidationStatusTypes } from '@/Components/Admin/Projects/PerformanceMarketing/PerformanceMarketingUtils';

export function taxPropertiesBuilder(taxValidationData, country, amount, currencySymbol) {
    if (!taxValidationData) {
        return buildTaxProperties(false, null);
    }

    const { status, taxRate, isValidatedByExternalService } = taxValidationData;

    const taxValue = getTaxValue(taxRate, amount);

    switch (status) {
    case taxIdValidationStatusTypes.exempt:
        return buildExemptTaxProperties();

    case taxIdValidationStatusTypes.standard:
        return buildStandardTaxProperties(taxRate, taxValue, country, isValidatedByExternalService, currencySymbol);

    case taxIdValidationStatusTypes.reverseCharge:
        return buildReverseChargeTaxProperties(country);

    case taxIdValidationStatusTypes.unknown:
        return buildUnknownTaxProperties();
    }
}

function buildTaxProperties(isSummaryItem, fieldDescription, additionalProperties = {}) {
    return {
        isSummaryItem,
        fieldDescription,
        ...additionalProperties,
    };
}

function buildExemptTaxProperties() {
    return buildTaxProperties(
        true,
        null,
        {
            isSummaryItem: true,
            summaryItemTitle: 'Tax:',
            taxValue: '-',
        });
}

function buildStandardTaxProperties(taxRate, taxValue, country, isValidatedByExternalService, currencySymbol) {
    return buildTaxProperties(
        true,
        isValidatedByExternalService
            ? 'The provided VAT number could not be verified in the VIES database. VAT reverse charge cannot be applied'
            : null,
        {
            summaryItemTitle: 'Tax:',
            hasSubtitle: true,
            subtitle: country,
            hasSubtitleTooltip: true,
            subtitleTooltipContent: buildTooltipText(taxRate, taxValue, currencySymbol),
            taxValue,
        });
}

function buildReverseChargeTaxProperties(country) {
    return buildTaxProperties(
        true,
        'The VAT number has been successfully verified. VAT reverse charge applies (no VAT will be calculated).',
        {
            summaryItemTitle: 'Tax:',
            hasSubtitle: true,
            subtitle: country,
            hasSubtitleTooltip: true,
            subtitleTooltipContent: [{ text: 'Tax details:' }, { text: 'VAT reverse' }],
            taxValue: '-',
        });
}

function buildUnknownTaxProperties() {
    return buildTaxProperties(false, null);
}
function getTaxValue(taxRate, amount) {
    if (taxRate === 0) {
        return '-';
    }
    return taxRate * amount;
}

function buildTooltipText(taxRate, taxValue, currencySymbol) {
    return [
        { text: 'Tax details:' },
        {
            text: taxRate > 0
                ? `${convertToPercentage(taxRate)}% - ${Formatter.format(taxValue, 'C2', currencySymbol)}`
                : `${convertToPercentage(taxRate)}%`,
        },
    ];
}